import { deriveEmailStage, EMAIL_STAGES } from "@/lib/emailStatus";
import type { ProspectStatus } from "@/lib/types";
import { cn } from "@/lib/utils";

export function EmailStatusTimeline({ status }: { status: ProspectStatus }) {
  const stage = deriveEmailStage(status);
  return (
    <div>
      <div className="flex items-center gap-2 text-xs">
        {EMAIL_STAGES.map((s, i) => (
          <div key={s.key} className="flex flex-1 items-center gap-2 last:flex-none">
            <span
              className={cn(
                "flex items-center gap-1 font-medium",
                i <= stage.index ? "text-aurora-green" : "text-neutral-400"
              )}
            >
              {i <= stage.index ? "●" : "○"} {s.label}
              {i === 0 && stage.validated && " (validé)"}
            </span>
            {i < EMAIL_STAGES.length - 1 && <span className="h-0.5 flex-1 bg-neutral-200" />}
          </div>
        ))}
      </div>
      {stage.terminal && stage.terminalLabel && (
        <p className="mt-2 text-xs font-medium text-red-600">{stage.terminalLabel}</p>
      )}
      <p className="mt-2 text-[10px] italic text-neutral-400">
        Les relances et événements Smartlead s'afficheront ici (V1.5).
      </p>
    </div>
  );
}
